<!--
//================================================================================
// ID:-
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:ReturnTop
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2022/01/20 | 富士通株式会社         | 新規作成
//================================================================================
-->
<template>
	<transition name="fade">
		<div id="pagetop">
			<a
				v-show="buttonActive"
				class="btn--returntop m-returntop"
				@click="co_toTop()"
			>先頭へ戻る</a>
		</div>
	</transition>
</template>

<script>
import { co_toTop } from '@/common/screenUtility.js';

export default {
	name: 'ReturnTop',
	data: function () {
		return {
			buttonActive: false,
			scroll: 0,
			co_toTop: co_toTop
		}
	},
	mounted() {
		window.addEventListener('scroll', this.scrollWindow)
	},
	methods: {
		scrollWindow() {
			const top = 380; // ボタンを表示させたい位置
			this.scroll = window.scrollY || window.pageYOffset;
			if (top <= this.scroll) {
				this.buttonActive = true;
			} else {
				this.buttonActive = false;
			}
		}
	}

}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
    opacity: 0;
}
/* 端末がPCの場合 */
@media screen and (min-width: 1080px) {
	.m-returntop {
		position: fixed;
		bottom: 19px;
		left: 50%;
		margin-left: 390px;
	}
}

/* 端末がスマホの場合 */
@media screen and (max-width: 1079px) {
	.m-returntop {
		position: fixed;
		bottom: 19px;
		right: 10px;
	}
}
</style>